module.exports = __webpack_public_path__ + "Flag-566.8e902e8b690726dd89df55970481885d.svg";